import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 10,
	fill: "none",
	viewBox: "0 0 8 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 7.33V2.67C0 1.43 0 .811.265.48.497.19.85.013 1.227 0c.434-.015.955.345 1.996 1.065l3.373 2.33c.783.541 1.174.812 1.313 1.148.121.293.121.62 0 .914-.139.336-.53.607-1.313 1.148l-3.373 2.33c-1.041.72-1.562 1.08-1.996 1.065a1.3 1.3 0 0 1-.962-.48C0 9.189 0 8.57 0 7.33"
	})
});
export default SvgPlay;
